import { useMockChartData } from '../useGenerateChartData'
import PlotComponent from './PlotComponent'

const HeatMap = () => {
  const { heatmapData } = useMockChartData()
  return (
    <PlotComponent
      data={[
        {
          z: heatmapData.map((point) => point.z),
          x: heatmapData.map((point) => point.x),
          y: heatmapData.map((point) => point.y),
          type: 'heatmap',
        },
      ]}
      layout={{ width: 500, height: 500, title: { text: 'Heatmap' } }}
    />
  )
}

export default HeatMap
